import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material';

interface SaveProgressItem {
  message: string;
  success: boolean;
}

interface SaveProgressDialogProps {
  open: boolean;
  savingComplete: boolean;
  saveProgress: SaveProgressItem[];
  onClose: () => void;
}

export const SaveProgressDialog: React.FC<SaveProgressDialogProps> = ({
  open,
  savingComplete,
  saveProgress,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (savingComplete) {
          onClose();
        }
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {savingComplete ? 'Save Complete' : 'Saving Data...'}
        {!savingComplete && <CircularProgress size={20} className="ml-2" />}
      </DialogTitle>
      <DialogContent>
        <div className="max-h-[400px] overflow-y-auto">
          {saveProgress.map((item, index) => (
            <div
              key={index}
              className={`py-1 px-2 text-sm ${item.success ? 'text-green-700' : 'text-red-700'}`}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {item.message}
            </div>
          ))}
          {!savingComplete && saveProgress.length === 0 && (
            <div className="text-gray-600 text-sm">Initializing save process...</div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        {savingComplete && (
          <Button onClick={onClose} color="primary" variant="contained">
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
